import { getLatestFlagVersionId } from '@gonfalon/experiments/getLatestFlagVersionId';
import type { IterationInput } from '@gonfalon/experiments/types';

export type CreateFlagsInputParams = {
  flagConfig: {
    flagKey: string;
    flagConfigVersion?: number;
    notInExperimentVariationId?: string;
    targetingRule?: string;
  };
  projectKey: string;
  environmentKey: string;
};

export const createFlagsInput = async ({
  flagConfig: { flagKey, flagConfigVersion, notInExperimentVariationId, targetingRule = '' },
  projectKey,
  environmentKey,
}: CreateFlagsInputParams): Promise<IterationInput['flags']> => {
  const latestFlagConfigVersion = await getLatestFlagVersionId({
    flagKey,
    projectKey,
    environmentKey,
    originalFlagConfigVersion: flagConfigVersion ?? 1,
  });
  return {
    [flagKey]: {
      flagConfigVersion: latestFlagConfigVersion,
      notInExperimentVariationId,
      ruleId: targetingRule,
    },
  };
};
